import React from "react";

export const initialValues = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
}

export const getErrorMessageToShow = (errors, touched) => {
    let error: string = '';

    if (errors.currentPassword && touched.currentPassword) {
        error = errors.currentPassword;
    }
    else if (errors.newPassword && touched.newPassword) {
        error = errors.newPassword;
    }
    else if (errors.confirmPassword && touched.confirmPassword) {
        error = errors.confirmPassword;
    }

    return error ? <span className='text-red-600 text-xs'>{error}</span> : null;
}
